import { ExportStatus } from '@aibees/shared/components/status-tag';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichTableDownloadActionProps as Props } from './types';

export const EnrichTableDownloadAction = memo(
  ({ className, item, rowNumber }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('EnrichTableDownloadAction', className)}
      >
        {item.state === ExportStatus.SUCCESS ? (
          <Stack sx={SX.iconWrapper}>
            <Icon name="download-outline" size={16} sxx={SX.icon} />
          </Stack>
        ) : (
          <Stack sx={SX.iconWrapper}>
            <Icon name="download-outline" size={16} sxx={SX.disabledIcon} />
          </Stack>
        )}
      </Styled.Wrapper>
    );
  }
);

EnrichTableDownloadAction.displayName = 'EnrichTableDownloadAction';
